import ItemView from '../ItemView';
import Modal from '../Modal';

interface ItemBuilderView {
  initialize(): void;
  terminate(): void;
  setState(state: ItemBuilderViewState): void;
  getState(): ItemBuilderViewState;

  getListViews(): ItemView[];
  getFolderViews(): ItemView[];
  getBreadCrumbViews(): ItemView[];

  getLastTarget(): Modal | undefined;
  setLastTarget(item: Modal): void;

  getLastCurrent(): Modal | undefined;
  setLastCurrent(item: Modal): void;

  getPositionX(): number;
  setPositionX(x: number): void;

  getPositionY(): number;
  setPositionY(y: number): void;

  resetLastUpdatedView(): void;

  getModel(): Modal;

  onChange(func: (model: Modal) => void): void;
  rerender(): void;
}

export enum ItemBuilderAction {
  FREE,
  DRAG,
}

export enum ItemBuilderViewType {
  FOLDER,
  BREADCRUMB,
  LIST,
  CARD,
}

export interface ItemBuilderViewState {
  action: ItemBuilderAction;
  current?: ItemView;
  target?: ItemView;
}

export default ItemBuilderView;
